import axios from 'axios';

export const createScreenHost = (hostData, token) => {
    return axios.post(process.env.REACT_APP_API_URL + '/admin/screenHostRegister', hostData, {
        headers: { Authorization: token }
    });
};
